import {Box, Flex, Heading, Text} from "@chakra-ui/react";


const Privacy = () => {


    return (
        <Flex
            borderRadius={'16px'}
            bg={'neutral.1100'}
            p={'32px 32px 250px 32px'}
            m={'auto'}
            maxW={'1440px'}
            flexDirection={'column'}
            color={'white'}
            gap={'40px'}
            my={'100px'}>
            <Box>
                <Heading fontSize={'display.sm'}>Privacy Policy</Heading>
                <Text fontSize={'body.lg'} color={'neutral.500'}>Last Update: 10 July, 2024</Text>
            </Box>
            <Flex
                position={'relative'}
                borderRadius={'8px'}
                bg={'neutral.1000'}
                h={'48px'}
                pl={'32px'}
                color={'neutral.100'}
                overflow={'hidden'}
                fontSize={'body.xl'}
                alignItems={'center'}
                borderLeft={'4px solid #5834A8'}>
                INTRODUCTION
                <Box
                    left={'-60px'}
                    position={'absolute'}
                    w={'99px'}
                    h={'99px'}
                    bg={'radial-gradient(50% 50% at 50% 50%, rgba(71, 121, 246, 0.35) 0%, rgba(0, 2, 140, 0) 100%)'}
                />
            </Flex>
            <Box
                color={'neutral.100'}
                fontSize={'body.xl'}>
                Thank you for visiting Arbito Trading Platform (“Arbito”). By visiting, accessing, or using Arbito and
                associated application program interface or mobile applications (“Site”), you consent to the policies
                and practices of our privacy policy (the “Privacy Policy”), PLEASE READ THIS PRIVACY POLICY
                CAREFULLY. <br/><br/>
                This Privacy Policy explains how Arbito uses your Personal Data (defined below) as we provide you with
                access and utility through our digital asset trading platform via software, API (application program
                interface), technologies, products, and/or functionalities (“Service”). <br/><br/>
                In the course of providing you our Service, to abide by the laws in the jurisdictions that we operate,
                and to improve our services, we need to collect and maintain personal information about you. As a rule,
                we never disclose any personal information about our customers to any non-affiliated third parties,
                except as described below. <br/><br/>
                We may update this Privacy Policy at any time and from time to time by posting the amended version on
                this Site.
            </Box>
            <Flex
                fontSize={'body.xl'}
                position={'relative'}
                borderRadius={'8px'}
                bg={'neutral.1000'}
                h={'48px'}
                color={'neutral.100'}
                pl={'32px'}
                overflow={'hidden'}
                alignItems={'center'}
                borderLeft={'4px solid #5834A8'}>
                DATA WE COLLECT
                <Box
                    left={'-60px'}
                    position={'absolute'}
                    w={'99px'}
                    h={'99px'}
                    bg={'radial-gradient(50% 50% at 50% 50%, rgba(71, 121, 246, 0.35) 0%, rgba(0, 2, 140, 0) 100%)'}
                />
            </Flex>
            <Box
                lineHeight={'30px'}
                color={'neutral.100'}
                fontSize={'body.xl'}>
                Arbito collects, processes, and stores Personal Data collected from you via your use of the Service or
                where you have given your consent. This Personal Data may include: <br/>
                <br/>
                <ul style={{paddingLeft: '30px'}}>
                    <li>
                        Virtual Identity: Arbito Account/Password, Arbito Nickname.
                    </li>
                    <li>
                        Financial Information: Bank account information, payment card primary account number (PAN),
                        account
                        assets, transaction history, trading data, and/or tax identification.
                    </li>
                    <li>
                        Transaction Information: Information about the transactions you make on the Platform, such as
                        the name
                        of the recipient, your name, the amount, and/or timestamp.
                    </li>
                    <li>
                        Message Content: Feedback, Email, SMS, App Rating, Comments.
                    </li>
                    <li>
                        Application Activity: Browsers and tap records, search history, installed apps, running apps,
                        crash
                        logs, user-generated content, favorites, mouse movement, scroll position, key events, and touch
                        events.
                    </li>
                    <li>
                        Device Information: Carrier, brand, software version, model name, manufacturer, system language,
                        OS
                        version, locale, fingerprint, Build ID, baseband version, SIM country, SIM serial number,
                        battery
                        status, network, OAID, IMEI, GUID, MAC address, Android ID, SSID, Advertising ID, and
                        gyroscope/accelerometer data.
                    </li>
                    <li>
                        Correspondence: Survey responses, information provided to our support team or user research
                        team.
                    </li>
                    <li>
                        Audio, electronic, visual, and similar information, such as call and video recordings.
                    </li>
                    <li>
                        Biometric data about yourself, including facial recognition data, fingerprint data, or other
                        biometric
                        data that may be used as a method of authentication on the Device used to access the Platform.
                    </li>
                </ul>
                <br/>
                We may collect information you provide during the Arbito onboarding process, which may be a completed,
                incomplete, or abandoned process. Offering services to residents in certain jurisdictions, we collect,
                store, and process your personal information in accordance with the provisions of your local data
                protection laws, such as the General Data Protection Regulation (GDPR) and Data Protection
                Act. <br/><br/>
                In addition, to stay in compliance with applicable Anti-Money Laundering laws and regulations, we may
                collect the following Personal Information: <br/>
                <br/>
                Individual customers: <br/>
                <br/>
                <ul style={{paddingLeft: '30px'}}>
                    <li>Email address</li>
                    <li>Mobile phone number</li>
                    <li>Full legal name (including former name and names in local language)</li>
                    <li>
                        Nationality
                    </li>
                    <li>
                        Passport number or any government-issued ID number
                    </li>
                    <li>
                        Date of birth (“DOB”)
                    </li>
                    <li>
                        Proof of identity (e.g., passport, driver’s license, or government-issued ID)
                    </li>
                    <li>
                        Residential address
                    </li>
                    <li>
                        Proof of residency
                    </li>
                </ul>
            </Box>

            <Flex
                fontSize={'body.xl'}
                position={'relative'}
                borderRadius={'8px'}
                bg={'neutral.1000'}
                h={'48px'}
                color={'neutral.100'}
                pl={'32px'}
                overflow={'hidden'}
                alignItems={'center'}
                borderLeft={'4px solid #5834A8'}>
                ACCESS, CORRECTION, DELETION AND OTHER RIGHTS RELATING TO YOUR PERSONAL DATA
                <Box
                    left={'-60px'}
                    position={'absolute'}
                    w={'99px'}
                    h={'99px'}
                    bg={'radial-gradient(50% 50% at 50% 50%, rgba(71, 121, 246, 0.35) 0%, rgba(0, 2, 140, 0) 100%)'}
                />
            </Flex>
            <Box fontSize={'body.xl'} color={'neutral.100'}>
                Subject to applicable law, as outlined below, you have a number of rights in relation to your privacy
                and the protection of your Personal Data. You have the right to request access to, correct, and delete
                your Personal Data, and to ask for data portability. You may also object to our processing of your
                Personal Data or ask that we restrict the processing of your Personal Data in certain instances. In
                addition, when you consent to our processing of your Personal Data for a specified purpose, you may
                withdraw your consent at any time. If you want to exercise any of your rights outlined below, please
                contact our Data Protection Officer by email via: dataprotect@FalconX.com. These rights may be limited
                in some situations - for example, where we are required by applicable laws or AML compliance practices
                to process your Personal Data. <br/><br/>
                -Right to access: you have the right to obtain confirmation that your Personal Data are processed and to
                obtain a copy of it as well as certain information related to its processing; <br/><br/>
                -Right to rectify: you can request the rectification of your Personal Data which are inaccurate, and
                also add to it. You can also change your Personal Data in your Account at any time. <br/><br/>
                -Right to delete: you can, in some cases, have your Personal Data deleted; <br/><br/>
                -Right to object: you can object, for reasons relating to your particular situation, to the processing
                of your Personal Data. For instance, you have the right to object where we rely on legitimate interest
                or where we process your Personal Data for direct marketing purposes; <br/><br/>
                -Right to restrict processing: You have the right, in certain cases, to temporarily restrict the
                processing of your Personal Data by us, provided there are valid grounds for doing so. We may continue
                to process your Personal Data if it is necessary for the defense of legal claims, or for any other
                reasons permitted by applicable law; <br/><br/>
                -Right to portability: in some cases, you can ask to receive your Personal Data which you have provided
                to us in a structured, commonly used and machine-readable format, or, when this is possible, that we
                communicate your Personal Data on your behalf directly to another data controller; <br/><br/>
                -Right to withdraw your consent: for processing requiring your consent, you have the right to withdraw
                your consent at any time. Exercising this right does not affect the lawfulness of the processing based
                on the consent given before the withdrawal of the latter. <br/><br/>
                Exercising of your rights above may impact the form and substance of the Services we provide to you, and
                in some circumstances, such exercise may mean that we will not be able to continue providing the
                Services to you, and we may need to terminate the contract you have with us. <br/><br/>
                We may charge you a reasonable fee for the handling and processing of your requests to access your
                personal data. If we choose to charge a fee, we will provide you with a written estimate of the fee that
                we will be charging. Please note that we are not required to respond to or deal with your request for
                access unless you have agreed to pay the fee.
            </Box>
        </Flex>
    )
}

export default Privacy